"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressTracker = ProgressTracker;
exports.ProgressTrackerItem = ProgressTrackerItem;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _index = require("../../index");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ProgressTracker(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      items = _ref.items,
      onClick = _ref.onClick,
      outlined = _ref.outlined,
      props = _objectWithoutProperties(_ref, ["className", "fill", "items", "onClick", "outlined"]);

  var filled = fill !== undefined ? fill : true;
  var classes = (0, _classnames.default)(_index.Classes.PROGRESS_TRACKER, _defineProperty({}, _index.Classes.FILL, filled), className);
  var currentIndex = items.findIndex(function (item) {
    return item.active === true;
  });
  var mayOutline = outlined !== undefined ? outlined : true;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, props), items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ProgressTrackerItem, _extends({
      fill: filled,
      key: item.id,
      index: index + 1,
      onClick: onClick
    }, item, {
      outlined: mayOutline && index <= currentIndex
    }));
  }));
}

function ProgressTrackerItem(_ref2) {
  var active = _ref2.active,
      fill = _ref2.fill,
      index = _ref2.index,
      id = _ref2.id,
      intent = _ref2.intent,
      onClick = _ref2.onClick,
      outlined = _ref2.outlined,
      text = _ref2.text,
      props = _objectWithoutProperties(_ref2, ["active", "fill", "index", "id", "intent", "onClick", "outlined", "text"]);
  /**
   * Wrappeed icon in Body to stop it resizing and to ensure it's vertically aligned properly.
   * This is because icons within body text are shifted down a little.
   */


  var intentIconMap = {
    danger: /*#__PURE__*/React.createElement(_index.Body, null, /*#__PURE__*/React.createElement(_index.Icon16, {
      icon: _index.IconNames16.ERROR,
      fill: (0, _index.intentColor)(_index.Intent.DANGER)
    })),
    success: /*#__PURE__*/React.createElement(_index.Body, null, /*#__PURE__*/React.createElement(_index.Icon16, {
      icon: _index.IconNames16.SUCCESS,
      fill: (0, _index.intentColor)(_index.Intent.SUCCESS)
    }))
  };
  var icon = /*#__PURE__*/React.createElement(_index.IndicatorTag, {
    intent: _index.Intent.NONE,
    outline: !active,
    small: true,
    text: index
  });

  if (intent === _index.Intent.DANGER || intent === _index.Intent.SUCCESS) {
    icon = intentIconMap[intent];
  }

  function handleClick() {
    if (onClick !== undefined) onClick(id);
  }

  var classes = (0, _classnames.default)(_index.Classes.PROGRESS_TRACKER_ITEM, _defineProperty({}, _index.Classes.FILL, fill), _defineProperty({}, _index.Classes.OUTLINED, outlined), _defineProperty({}, _index.Classes.ACTIVE, active));
  return /*#__PURE__*/React.createElement(_index.Card, _extends({
    level: _index.CardLevel.FILLED,
    paddingLevel: _index.PaddingLevel.CONDENSED,
    onClick: handleClick,
    className: classes
  }, props), /*#__PURE__*/React.createElement(_index.Tooltip, {
    content: text,
    targetTagName: "div",
    wrapperTagName: "div"
  }, /*#__PURE__*/React.createElement("div", {
    className: _index.Classes.PROGRESS_TRACKER_ITEM_CONTENT
  }, icon, /*#__PURE__*/React.createElement(_index.Body, {
    muted: !active,
    intent: intent,
    className: _index.Classes.TEXT_OVERFLOW_ELLIPSIS
  }, text))));
}